import { Tag } from "antd";
import type { SubscriptionListItem } from "../types";

/** Один тег который показывает статус подписки одним взглядом.
 *
 * Приоритеты (от высокого к низкому):
 *  1. 🔒 Отозвана         — hysteria_revoked_at != null (admin /revoke/reset_key/ban)
 *  2. ⚠ Авто-блок         — shared_block_until активен (sharing-детектор)
 *  3. 🎁 Пробный доступ   — is_trial && is_active (наш 2-дневный trial)
 *  4. ✅ Активна           — обычная платная подписка, не истекла
 *  5. ⌛ Истекла           — end_at в прошлом
 */
export const SubStatusTag = ({ s }: {
  s: Pick<SubscriptionListItem,
    "is_active" | "hysteria_revoked_at" | "shared_block_until" | "end_at" | "is_trial">;
}) => {
  if (s.hysteria_revoked_at) {
    return <Tag color="red">🔒 Отозвана</Tag>;
  }
  if (s.shared_block_until && new Date(s.shared_block_until) > new Date()) {
    return <Tag color="volcano">⚠ Авто-блок</Tag>;
  }
  if (s.is_trial && s.is_active) {
    return <Tag color="gold">🎁 Пробный доступ</Tag>;
  }
  if (s.is_active) return <Tag color="green">✅ Активна</Tag>;
  if (s.is_trial) return <Tag>🎁⌛ Пробный истёк</Tag>;
  return <Tag>⌛ Истекла</Tag>;
};
